module.exports = __webpack_public_path__ + "static/img/tky-kcbg2-nor@2x.cc667770.png";